import actions from './actions'
import getters from './getters'
import types from '/src/store/types'

const state = {
  specificQueryParams: {}
}

const mutations = {
  [types.marketing.SET_SPECIFIC_QUERY_PARAMS_FULLY] (state, params) {
    state.specificQueryParams = params
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/marketing/index.js